import { savedTokens } from 'src/auth'
import { ErrorNotLoggedIn, Title } from 'src/components'
import { OrganizationTable } from './components/org-table'
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/ui/tabs'
import { SubscriberTable } from './components/subscriber-table'
import { OrgRegionsTable } from './components/orgregions-table'
import { ReactNode } from 'react'
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'src/ui/alert-dialog'

type Props = {
  username: string
}

function AdminOrganizationsOverview(props: Props) {
  return (
    <>
      <div className="flex items-center text-secondary gap-5 mb-8">
        <Title label="Organization Data" />
        <p>
          <span>eu-central-1</span>
          <span className="mx-3">|</span>
          <span>us-east-1</span>
        </p>
      </div>

      <Tabs defaultValue="lastused" className="w-full">
        <TabsList className="flex max-w-5xl m-auto items-start">
          <TabsTrigger value="lastused">Organizations</TabsTrigger>
          <TabsTrigger value="subscriber">Subscribers</TabsTrigger>
          <TabsTrigger value="regions">Org Regions</TabsTrigger>
        </TabsList>
        <TabsContent value="lastused" className="flex flex-col bg-white">
          <OrganizationTable username={props.username} />
        </TabsContent>
        <TabsContent value="subscriber" className="flex flex-col bg-white">
          <SubscriberTable username={props.username} />
        </TabsContent>
        <TabsContent value="regions" className="flex flex-col bg-white">
          <OrgRegionsTable username={props.username} />
        </TabsContent>
      </Tabs>
    </>
  )
}

type PropsAlert = {
  open: boolean
  setOpenChange: (value: boolean) => void
  children: ReactNode
  info: string
}

export const AlertDialogDelete = (props: PropsAlert) => {
  return (
    <AlertDialog open={props.open} onOpenChange={props.setOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete data
            linked to <span className="font-bold">{props.info}</span> from our
            data.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>{props.children}</AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default function ValidateConfig() {
  const [tokens] = savedTokens.useState(null)
  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  return <AdminOrganizationsOverview username={tokens.username} />
}
